import React, { Component } from "react";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IMaterialsTypeaheadDTO from "../../../../../models/DTO/IMaterialsTypeaheadDTO";
import IOnMaterialsTypeaheadDTO from "../../../../../models/DTO/IOnMaterialsTypeaheadDTO";
import IMaterial from "../../../../../models/IMaterial";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import "./MaterialsDetail.scss";
import UIService from "../../../../../services/UIService";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import Typeahead from "../../../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    notify: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    materials: IMaterial[];
    materialsQtySet: { material: IMaterial; qty: number }[];
    updateMaterialsFn: (qtySet: { material: IMaterial; qty: number }[]) => void;
    deleteMaterialsFn: (material: IMaterial, index: number) => void;
};

type State = {
    typeaheadItems: IMaterial[];
    selectedMaterial?: IMaterial;
    materials: IMaterial[];
    qtySet: { material: IMaterial; qty: number }[];
    clearTypeahead: boolean;
};

class MaterialsDetail extends Component<Props, State> {
    readonly state: State = {
        typeaheadItems: [],
        materials: this.props.materials,
        qtySet: this.props.materialsQtySet,
        clearTypeahead: false,
    };

    componentDidMount(): void {
        this.props.socket.on("onMaterialsTypeahead", this.onGetMaterialTypeahead);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onMaterialsTypeahead", this.onGetMaterialTypeahead);
    }

    getMaterialTypeahead = (name: string) => {
        const payload: IMaterialsTypeaheadDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit("materialsTypeahead", payload);
    };

    onGetMaterialTypeahead = (data: IOnMaterialsTypeaheadDTO) => {
        this.setState({
            typeaheadItems: data.materials,
        });
    };

    selectedItem = (material: IMaterial) => {
        this.setState({
            selectedMaterial: material,
        });
    };

    addSelectedItem = () => {
        if (this.state.selectedMaterial) {
            const materials = this.state.materials;

            materials.push(this.state.selectedMaterial);

            this.setState({
                materials,
                selectedMaterial: undefined,
                clearTypeahead: true,
            });
        }
    };

    setQty = (material: IMaterial, index: number, e: any) => {
        const qtySet = this.state.qtySet;

        let found = false;

        for (const setItem of qtySet) {
            if (setItem.material === material) {
                setItem.qty = e.target.value;
                found = true;
            }
        }

        if (!found) {
            const setItem = {
                material,
                qty: e.target.value,
            };

            qtySet.push(setItem);
        }

        this.setState(
            {
                qtySet,
            },
            () => {
                this.props.updateMaterialsFn(this.state.qtySet);
                // emit the update to the sidebar / parent component
            }
        );
    };

    clearTypeahead = () => {
        this.setState({
            selectedMaterial: undefined,
            clearTypeahead: false,
        });
    };

    deleteMaterial = (material: IMaterial, index: number) => {
        const materials = this.state.materials;

        materials.splice(index, 1);

        this.setState(
            {
                materials,
            },
            () => {
                this.props.deleteMaterialsFn(material, index);
            }
        );
    };

    render() {
        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = "";
        }

        return (
            <div className="MaterialsDetail mt-2">
                <div className={"bd-callout"}>
                    <OwLabel title={"materials"} leftIconClass={"fad fa-cubes"} />
                </div>

                <div className={"d-flex flex-row"}>
                    <Typeahead
                        outerWrapperClassName={"w-100"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.getMaterialTypeahead}
                        typeaheadItems={this.state.typeaheadItems}
                        titleProp={"name"}
                        selectedItemFn={this.selectedItem}
                        selectedItemTitleProp={"name"}
                        clearTypeaheadCallback={this.clearTypeahead}
                        clearTypeahead={this.state.clearTypeahead}
                        placeholder={"search_materials"}
                    />

                    <div>
                        <OwButton title={"add"} fn={this.addSelectedItem} />
                    </div>
                </div>

                <div>
                    <table className={`table table-borderless ${tableClass}`}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    <OwLabel title={"name"} noBottomMargin={true} />
                                </th>
                                <th>
                                    <OwLabel title={"qty"} noBottomMargin={true} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.materials.map((material, index: number) => {
                                const qtySetItem = this.state.qtySet[index];
                                let qty = 0;

                                if (qtySetItem && qtySetItem.material === material) {
                                    qty = qtySetItem.qty;
                                }

                                return (
                                    <tr key={material.guid}>
                                        <td>
                                            {
                                                <i
                                                    className={"fas fa-trash-alt text-danger pointer"}
                                                    onClick={() => {
                                                        this.deleteMaterial(material, index);
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td>{material.name}</td>
                                        <td>
                                            <OwInputWrapper
                                                name={"qty"}
                                                fn={(e: any) => {
                                                    this.setQty(material, index, e);
                                                }}
                                                value={qty}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default MaterialsDetail;
